'use client';

import { FC } from 'react';
import { SliceZone } from '@prismicio/react';
import { HeaderDocument } from '../../../../../prismicio-types';

import { components } from '@/slices';
import { Button } from '@/components';

import { BurgerMenu } from './BurgerMenu';
import styles from './navigationMenu.module.scss';

type Props = {
  page: HeaderDocument<string>;
  isOpen: boolean;
  onClick: () => void;
};

export const NavigationMenu: FC<Props> = ({ page, isOpen, onClick }) => {
  return (
    <>
      <div
        className={`${styles.navigation_container} ${isOpen ? styles.isOpen : styles.isClose}`}
      >
        <nav className={styles.nav}>
          <ul className={styles.list}>
            <SliceZone slices={page.data.slices} components={components} />
          </ul>
        </nav>
        <div className={styles.button_container}>
          <Button
            link={page.data.button_link}
            text={page.data.button_text}
            styles={styles.button}
            variation="primary"
          />
        </div>
      </div>
      <BurgerMenu isOpen={isOpen} onClick={onClick} />
    </>
  );
};
